import { z } from "zod";

export const SensorAgentSchema = z.object({
  sensor_agent_id: z.number().int().optional(),
  sensor_agent_name: z.string().trim().min(1),
  sensor_agent_type: z.string().trim().min(1),
  sensor_agent_os_type: z.string().trim().min(1),
  sensor_agent_cpu_type: z.string().trim().min(1),
  sensor_agent_state: z.string().nullable(),
  sensor_agent_version: z.string().nullable(),
  device_usage_count: z.number().int().default(0),
  sensor_agent_url: z.string().trim().min(1),
});

export type SensorAgent = z.infer<typeof SensorAgentSchema>;
